define([
	'jquery',
	'pubsub'
], function( $, pubsub ) {

	var PLUGIN_IDENTIFIER = "scrolltotop";
	var scrolltotop = function( element, options ) {
		this.element = element;
		this.options = options;
	};

	scrolltotop.prototype = {
		defaults: {
			scrollSpeed: 800, // How fast to scroll to the top of the page
			topThreshold: 100 // Distance from top to wait until showing button
		},

		init: function() {
			var self = this;
			
			// Merge the options and defaults into a config object
			self.config = $.extend( {}, self.defaults, self.options);

			self.events();

			return self;
		},

		/**
		 * Setup plugin events
		 **/
		events: function() {
			var self = this;
			var $this = $(self.element);

			// Scroll to top when user clicks
			$this.on('click', function(e) {
				e.preventDefault();
				$("body, html").animate({
		        scrollTop : 0
		    }, self.config.speed);
			});

			// On window scroll, show/hide element depending on how far down user has scrolled
			$.pubsub('subscribe', 'window.scroll', function(event, data) {
				if(data.now > self.config.topThreshold) {
					$this.removeClass('hide');
				} else {
					$this.addClass('hide');
				}
			});
		}
	};

	scrolltotop.defaults = scrolltotop.prototype.defaults;

	// prevent duplicate instantiation
	$.fn.scrolltotop = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new scrolltotop(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};
});